import { Types } from 'service-api'
import { i18WithDefault as t } from './locales'
export type GroupedUnusedVouchers = Record<string, Record<string, Record<string, number>>>

export const formatUnusedVouchers = (unusedVouchers?: Types.ReportAdminDto) => {
  return (unusedVouchers?.subReports || []).reduce(
    (acc, speciesReport) => {
      speciesReport.subReports?.forEach((locationServiceTypeReport) => {
        locationServiceTypeReport.subReports?.forEach((offerTypeReport) => {
          offerTypeReport.subReports?.forEach((voucherReport) => {
            const key = `${locationServiceTypeReport.groupId}-${voucherReport.groupId}`
            const entry = {
              groupName: `${locationServiceTypeReport.title}, ${voucherReport.title}`,
              value: voucherReport.values?.[0] || 0,
            }
            if (acc[key]) {
              acc[key].value += entry.value
            } else {
              acc[key] = entry
            }
          })
        })
      })
      return acc
    },
    {} as Record<string, { groupName: string; value: number }>
  )
}

export const voucherApplicableToLabel = (applicableTo: string | undefined) => {
  switch (applicableTo) {
    case 'PRIMARY':
      return t('global.label.primaryOffer')
    case 'SERVICE':
      return t('global.label.roomUpgrade')
    case 'PET':
      return t('global.label.petPerk')
    default:
      return t('global.label.anyOfferType')
  }
}

export const formatUnusedVouchersDevOnly = (unusedVouchers?: Types.ReportAdminDto) => {
  const result: { groupName: string; value: number }[] = []
  unusedVouchers?.subReports?.forEach((speciesReport) => {
    speciesReport.subReports?.forEach((locationServiceTypeReport) => {
      locationServiceTypeReport.subReports?.forEach((offerTypeReport) => {
        offerTypeReport.subReports?.forEach((voucherReport) => {
          const groupName = [
            speciesReport.title?.toLowerCase() === 'all' ? t('global.label.anySpecies') : speciesReport.title,
            locationServiceTypeReport.title?.toLowerCase() === 'all'
              ? t('global.label.anyPrimaryService')
              : locationServiceTypeReport.title,
            voucherApplicableToLabel(offerTypeReport.title),
          ]
            .filter(Boolean)
            .join(', ')

          result.push({
            groupName: `${groupName} - ${voucherReport.title}`,
            value: voucherReport.values?.[0] || 0,
          })
        })
      })
    })
  })
  result.sort((a, b) => b.value - a.value)
  return result
}

export const groupUnusedVouchers = (unusedVouchers?: Types.ReportAdminDto) => {
  return (unusedVouchers?.subReports || []).reduce((acc, speciesReport) => {
    const speciesReportGroupId = speciesReport.groupId
    if (!speciesReportGroupId) return acc

    speciesReport.subReports?.forEach((locationServiceTypeReport) => {
      const locationServiceTypeReportGroupId = locationServiceTypeReport.groupId
      if (!locationServiceTypeReportGroupId) return

      locationServiceTypeReport.subReports?.forEach((offerTypeReport) => {
        const offerTypeReportGroupId = offerTypeReport.groupId
        if (!offerTypeReportGroupId) return

        offerTypeReport.subReports?.forEach((voucherReport) => {
          if (!acc[speciesReportGroupId]) {
            acc[speciesReportGroupId] = {}
          }
          if (!acc[speciesReportGroupId][locationServiceTypeReportGroupId]) {
            acc[speciesReportGroupId][locationServiceTypeReportGroupId] = {}
          }
          acc[speciesReportGroupId][locationServiceTypeReportGroupId][offerTypeReportGroupId] =
            (acc[speciesReportGroupId][locationServiceTypeReportGroupId][offerTypeReportGroupId] || 0) +
            (voucherReport.values?.[0] || 0)
        })
      })
    })
    return acc
  }, {} as GroupedUnusedVouchers)
}
